namespace RedBullMOBILE360.LoanWhitelist {
    export class LoanWhitelistColumns {
        static columnsKey = 'LoanWhitelist.LoanWhitelist';
    }
}